/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Remove_Super_Admin_LastInputs */



/**
* | output |
* | --- |
* | "Cannot remove the last administrator. Invite a replacement first." |
*
* @param {Partner_Admin_Remove_Super_Admin_LastInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_remove_super_admin_last = /** @type {((inputs?: Partner_Admin_Remove_Super_Admin_LastInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Remove_Super_Admin_LastInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der letzte Administrator kann nicht entfernt werden. Laden Sie zuerst eine Vertretung ein.")
	return /** @type {LocalizedString} */ ("Cannot remove the last administrator. Invite a replacement first.")
});